var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('span',{staticClass:"lease-status-tag",class:'is-' + _vm.tagType},[_vm._v(_vm._s(_vm.label))]):_c('span',{staticClass:"lease-status-empty"},[_vm._v(_vm._s(_vm.emptyText))])}
var staticRenderFns = []

export { render, staticRenderFns }